import { ReferencedEntry } from 'contentful';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ContentType, SolutionPickerModule } from 'src/api/contentful/contentTypes.cloverdotcom';
import { fetchEntries } from 'src/api/contentful/fetchEntries';
import { get } from 'src/utils/EntryUtil';

export function useContentfulEmptyCart () {
  const [item, setItem] = useState<ReferencedEntry<SolutionPickerModule>>();
  const { language } = useTranslation().i18n;

  const CONTENT_TYPE = ContentType.SOLUTION_PICKER_MODULE;

  const fetchSolutionPicker = () => {

    fetchEntries<SolutionPickerModule>(language, {
      contentType: CONTENT_TYPE,
      filters: { fields: { isUsedWithEmptyCartPage : true } },
      include : 3,
    }).then(entries => {
      const [entry] = get(entries, 'items', []) as Array<ReferencedEntry<SolutionPickerModule>>;
      setItem(entry);
    }).catch(err =>
      console.error(`Problem pulling ${CONTENT_TYPE} from Contentful`, err)
    );
  };

  useEffect(() => {
    fetchSolutionPicker();
  }, [language, setItem]);

  return item;
}
